import { TEMPLATE_GROUPS, getTemplateById } from "@/utils/automation-templates";
import type { FC } from "react";
import { useSearchParams } from "react-router-dom";
import { AutomationEditPage } from "@/routes/automations/automation-edit-page/AutomationEditPage";

const DEFAULT_TEMPLATE = TEMPLATE_GROUPS["from-scratch"].templates["start-from-scratch"];

export const NewAutomationPage: FC = () => {
    const [searchParams] = useSearchParams();

    const templateIdFromSearchParams = searchParams.get("template");
    const template = (templateIdFromSearchParams && getTemplateById(templateIdFromSearchParams)) || DEFAULT_TEMPLATE;

    return <AutomationEditPage template={template} />;
};
